import { AMLExportService } from "./AMLExportService";
import { HuruCriminalCheckExportService } from "./HuruCriminalCheckExportService";
import { OcrLivenessExportService } from "./OcrLivenessExportService";
import { IndividualLivenessExportService } from "./IndividualLivenessExportService";
import { ComprehensiveLivenessExportService } from "./ComprehensiveLivenessExportService";
import { RsaIdExportService } from "./RsaIdExportService";
import { OcrExportService } from "./OcrExportService";
import { IdLivenessExportService } from "./IdLivenessExportService";
import { EnterpriseAmlExportService } from "./EnterpriseAmlExportService";
import { EnterpriseCreditExportService } from "./EnterpriseCreditExportService";
import { TelephoneExportService } from "./TelephoneExportService";

/**
 * Export Service Factory
 *
 * Creates the appropriate export service based on the service type
 *
 * @param {string} service_type - The type of service
 * @param {Object} data - The data to export
 * @param {Object} metadata - Additional metadata
 * @returns {BaseExportService} - The appropriate export service instance
 */
export function export_service_factory(service_type, data, metadata = {}) {
  switch (service_type) {
    case "aml":
      return new AMLExportService(data, metadata);

    case "ocr_liveness":
      return new OcrLivenessExportService(data, metadata);

    case "individual_liveness":
      return new IndividualLivenessExportService(data, metadata);

    case "comprehensive_liveness":
      return new ComprehensiveLivenessExportService(data, metadata);

    case "rsa_id_verification":
      return new RsaIdExportService(data, metadata);

    case "ocr_verification":
      return new OcrExportService(data, metadata);

    case "id_liveness":
      return new IdLivenessExportService(data, metadata);

    case "enterprise_aml":
      return new EnterpriseAmlExportService(data, metadata);

    case "enterprise_credit":
      return new EnterpriseCreditExportService(data, metadata);

    case "huru_criminal_check":
      return new HuruCriminalCheckExportService(data, metadata);

    case "telephones":
      return new TelephoneExportService(data, metadata);

    default:
      throw new Error(`Unknown service type: ${service_type}`);
  }
}

/**
 * Available service types
 */
export const EXPORT_SERVICE_TYPES = {
  AML: "aml",
  OCR_LIVENESS: "ocr_liveness",
  INDIVIDUAL_LIVENESS: "individual_liveness",
  COMPREHENSIVE_LIVENESS: "comprehensive_liveness",
  RSA_ID_VERIFICATION: "rsa_id_verification",
  OCR_VERIFICATION: "ocr_verification",
  ID_LIVENESS: "id_liveness",
  ENTERPRISE_AML: "enterprise_aml",
  ENTERPRISE_CREDIT: "enterprise_credit",
  HURU_CRIMINAL_CHECK: "huru_criminal_check",
};
